






import { Component, Vue } from 'vue-property-decorator'

import AppTemplate from '@/components/templates/App.vue'
import PlainTemplate from '@/components/templates/Plain.vue'

@Component({
  components: { AppTemplate, PlainTemplate },
})
class App extends Vue {}

export default App
